import { render } from "./UserProfileFormModal.vue?vue&type=template&id=36205e31&ts=true"
import script from "./UserProfileFormModal.vue?vue&type=script&lang=ts"
export * from "./UserProfileFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__